import { Stack, Box } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { MarkdownWrapper } from '../../../common/MarkdownWrapper';
import { CopyToClipboardButton } from '../copy-to-clipboard/CopyToClipboardButton';
import { UsePromptInChatButton } from '../UsePromptInChatButton';
import { PromptWithCategory } from '../types';

interface PromptExpandableContentProps {
  prompt: PromptWithCategory;
  onUseInChatSuccess: () => void;
  displaySmallUsePromptInChatButton?: boolean;
}

export const PromptExpandableContent = ({
  prompt,
  onUseInChatSuccess,
}: PromptExpandableContentProps) => {
  return (
    <Box
      sx={{
        padding: 3,
        backgroundColor: colors.white,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
      }}
    >
      <MarkdownWrapper content={prompt.promptText} removeMargins={true} color={colors.grey[700]} />

      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        gap={3}
        sx={{
          borderTop: `1px solid ${colors.grey[300]}`,
          paddingTop: 3,
        }}
      >
        <CopyToClipboardButton textToCopy={prompt.promptText} />
        <UsePromptInChatButton
          promptText={prompt.promptText}
          onSuccess={onUseInChatSuccess}
          displaySmallVersion
        />
      </Stack>
    </Box>
  );
};
